import { createdAtToTimestamp } from './createdAtToTimestamp'
import { getChatSession } from './getChatSession'
import { isAgent } from './isAgent'
import { renderAgent } from './renderAgent'
import { saveChatSession } from './saveChatSession'

/**
 *
 * @param {import('@livechat/customer-sdk').CustomerSDK} instance
 * @param {string} chatId
 */
export async function restoreMessagesFromHistory(instance, chatId) {
  const history = instance.getChatHistory({
    chatId,
  })

  const result = await history.next()

  if (result.done) {
    return
  }

  const threads = result.value?.threads
  if (!threads) {
    return
  }

  const events = threads
    .map((thread) => thread.events || [])
    .reduce((acc, current) => acc.concat(current), [])

  const messages = events
    .filter((e) => e.type === 'message' || e.type === 'system_message')
    .map((e) => {
      /** @type {ChatSessionMessage} */
      const message = {
        authorId: e.authorId,
        authorType:
          e.type === 'system_message'
            ? 'system'
            : isAgent(e.authorId)
              ? 'agent'
              : 'user',
        id: e.id,
        text: e.text,
        timestamp: createdAtToTimestamp(e.createdAt),
      }
      return message
    })

  const session = getChatSession()

  if (messages.length > 0) {
    session.conversation = messages
  }

  const lastAgentMessage = session.conversation
    .filter((m) => m.authorType === 'agent')
    .pop()

  if (lastAgentMessage) {
    const agent = session.users.find((u) => u.id === lastAgentMessage.authorId)
    if (agent) {
      renderAgent(agent.name, agent.avatar || '')
    }
  }

  saveChatSession({
    ...session,
    conversation: messages,
  })
}
